import { render, staticRenderFns } from "./PrintCheck.vue?vue&type=template&id=36c1ed83&scoped=true&"
import script from "./PrintCheck.vue?vue&type=script&lang=js&"
export * from "./PrintCheck.vue?vue&type=script&lang=js&"
import style0 from "./PrintCheck.vue?vue&type=style&index=0&id=36c1ed83&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c1ed83",
  null
  
)

export default component.exports